export const contactInfo = {
  name: "Juhler Fodpleje",
  owner: "Pernille Juhler",
  address: "Fjordvænget 9, Kollund",
  zipCity: "6340 Kruså",
  clinics: [
    {
      name: "Kollund Klinik",
      address: "Fjordvænget 9",
      zipCity: "6340 Kruså",
      area: "Kruså / Padborg & omegn"
    },
    {
      name: "Dyreborg Klinik",
      address: "Knoldsborgvej 6",
      zipCity: "5600 Faaborg",
      area: "Faaborg / Millinge & omegn"
    }
  ],
  phone: "+4541836530",
  phoneDisplay: "+45 41 83 65 30",
  email: "pjuhler@live.dk",
  area: "Kruså / Padborg & omegn samt Faaborg / Millinge & omegn (Klinik & Udekørende)",
  hours: "Efter aftale",
};

export const pricing = [
  {
    id: "fodbehandling",
    category: "Fodbehandlinger",
    description: "Professionel fodpleje med fokus på både sundhed og velvære – tilbydes både i klinikken og som udekørende service i dit eget hjem. Som lægeexamineret fodplejer sørger jeg for, at dine fødder får den nødvendige opmærksomhed i trygge rammer.",
    image: "/images/fodbehandling-basic.png",
    items: [
      {
        title: "Almindelig fodbehandling",
        price: "450,-",
        description: "En grundig behandling (ca. 60 min.) der inkluderer et afslappende fodbad, klipning og rensning af negle, fjernelse af hård hud og evt. ligtorne. Behandlingen afsluttes med en plejende creme samt en let, afslappende fodmassage, såfremt tiden tillader det.",
      },
      {
        title: "Almindelig fodbehandling inkl. gel",
        price: "675,-",
        description: "En almindelig fodbehandling (ca. 90-120 minutter) kombineret med pålægning af professionel, flot og slidstærk gel på tåneglene for et langtidsholdbart resultat.",
      },
      {
        title: "Udvidet fodbehandling",
        price: "550,-",
        description: "Til fødder med særlige udfordringer, f.eks. meget kraftig hornhudsdannelse, mange ligtorne eller komplekse negleproblemer, der kræver ekstra tid og ekspertise.",
      },
      {
        title: "Specialbehandling",
        price: "275,-",
        description: "En fokuseret behandling af et enkelt problem – enten nedgroede negle, ligtorn eller fodvorter.",
      },
      {
        title: "Delbehandling",
        price: "350,-",
        description: "Fokuseret behandling med enten negleklip eller fjernelse af hård hud.",
      },
    ],
  },
  {
    id: "udebehandling",
    category: "Klinik & Udebehandling",
    description: "Juhler Fodpleje er både udekørende og har faste klinikker. Du kan vælge at få behandlingen i en af mine faste klinikker eller få besøg i trygge, vante rammer i dit eget hjem, på plejehjem eller institutioner.",
    image: "/images/fodbehandling-mobile.png",
    items: [
      {
        title: "Hjemmebesøg / Mobil fodpleje",
        price: "450,-",
        description: "Jeg kommer hjem til dig med alt nødvendigt udstyr. Du skal blot læne dig tilbage og nyde behandlingen i vante rammer.",
      },
      {
        title: "Institutioner & Plejehjem",
        price: "Kontakt for tilbud",
        description: "Behandlinger tilbydes også på institutioner og plejehjem.",
        subOption: {
          title: "Institutioner & Plejehjem",
          price: "(ingen kørselsgebyr)",
        },
      },
    ],
  },
  {
    id: "tillaeg",
    category: "Tillægsydelser",
    description: "Gør din behandling endnu mere personlig med mine udvalgte tillægsydelser, der giver det sidste strejf af velvære.",
    image: "/images/additional-treatments.png",
    items: [
      {
        title: "Lakering af negle",
        price: "150,-",
        description: "Kunden må gerne medbringe egen neglelak af hensyn til hygiejnen.",
      },
    ],
  },
];
